export enum NotificationType {
    // Orders
    ORDER_PLACED = 'ORDER_PLACED',
    ORDER_CONFIRMED = 'ORDER_CONFIRMED',
    ORDER_SHIPPED = 'ORDER_SHIPPED',
    ORDER_DELIVERED = 'ORDER_DELIVERED',
    ORDER_CANCELLED = 'ORDER_CANCELLED',

    // Payments
    PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
    PAYMENT_FAILED = 'PAYMENT_FAILED',

    // Inventory
    LOW_STOCK = 'LOW_STOCK',
    OUT_OF_STOCK = 'OUT_OF_STOCK',

    // Import/Export
    PRODUCT_IMPORT_COMPLETED = 'PRODUCT_IMPORT_COMPLETED',
    PRODUCT_IMPORT_FAILED = 'PRODUCT_IMPORT_FAILED',

    // Shipment
    SHIPMENT_STATUS_CHANGED = 'SHIPMENT_STATUS_CHANGED',

    // Returns
    RETURN_REQUESTED = 'RETURN_REQUESTED',
    RETURN_APPROVED = 'RETURN_APPROVED',
    RETURN_REJECTED = 'RETURN_REJECTED',

    // Subscription
    SUBSCRIPTION_EXPIRING = 'SUBSCRIPTION_EXPIRING',
    SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
    SUBSCRIPTION_RENEWED = 'SUBSCRIPTION_RENEWED',

    // Quota
    QUOTA_WARNING = 'QUOTA_WARNING',
    QUOTA_EXCEEDED = 'QUOTA_EXCEEDED',

    // Discounts
    DISCOUNT_CREATED = 'DISCOUNT_CREATED',
    DISCOUNT_EXPIRING = 'DISCOUNT_EXPIRING',

    // Team
    INVITATION_RECEIVED = 'INVITATION_RECEIVED',
    INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
    TEAM_MEMBER_ADDED = 'TEAM_MEMBER_ADDED',
    TEAM_MEMBER_REMOVED = 'TEAM_MEMBER_REMOVED',

    // System
    SYSTEM_ANNOUNCEMENT = 'SYSTEM_ANNOUNCEMENT',
    CUSTOM = 'CUSTOM'
}

export enum NotificationSeverity {
    INFO = 'INFO',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    ERROR = 'ERROR'
}

export enum NotificationChannel {
    IN_APP = 'IN_APP',
    EMAIL = 'EMAIL',
    BOTH = 'BOTH'
}

export interface NotificationDTO {
    id: number;
    recipientUserId: number;
    clientAccountId?: number;
    type: NotificationType;
    severity: NotificationSeverity;
    channel: NotificationChannel;
    title: string;
    message: string;
    actionUrl?: string;
    referenceEntityType?: string;
    referenceEntityId?: number;
    read: boolean;
    readAt?: string;
    emailSent?: boolean;
    metadata?: string;
    createdBy?: string;
    createdDate?: string;
}

export interface UnreadCountResponse {
    count: number;
}

export interface MarkAllReadResponse {
    markedAsRead: number;
}
